var _rect, _g, _rect2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPrintButton(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_626_7073",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 4,
    y: 4,
    width: 24,
    height: 24
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 4,
    y: 4,
    width: 24,
    height: 24,
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_626_7073)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M20 12V9H12V12H10V7H22V12H20ZM22 16.5C22.2833 16.5 22.5207 16.404 22.712 16.212C22.904 16.0207 23 15.7833 23 15.5C23 15.2167 22.904 14.979 22.712 14.787C22.5207 14.5957 22.2833 14.5 22 14.5C21.7167 14.5 21.4793 14.5957 21.288 14.787C21.096 14.979 21 15.2167 21 15.5C21 15.7833 21.096 16.0207 21.288 16.212C21.4793 16.404 21.7167 16.5 22 16.5ZM20 23V19H12V23H20ZM22 25H10V21H6V15C6 14.15 6.29167 13.4377 6.875 12.863C7.45833 12.2877 8.16667 12 9 12H23C23.85 12 24.5627 12.2877 25.138 12.863C25.7127 13.4377 26 14.15 26 15V21H22V25ZM24 19V15C24 14.7167 23.904 14.479 23.712 14.287C23.5207 14.0957 23.2833 14 23 14H9C8.71667 14 8.479 14.0957 8.287 14.287C8.09567 14.479 8 14.7167 8 15V19H10V17H22V19H24Z",
    fill: "#616161"
  }))), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 31,
    height: 31,
    rx: 3.5,
    stroke: "#616161"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPrintButton);
export default __webpack_public_path__ + "static/media/PrintButton.24ab94a8d819200c8b011a4513c41042.svg";
export { ForwardRef as ReactComponent };